import React from "react";

const TermsAndConditions = () => {
  const lastUpdatedDate = "2025"; // <-- CHANGE THIS

  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        {/* Page Title */}
        <h1 className="text-4xl font-bold text-gray-800">Terms and Conditions</h1>
        <p className="text-gray-500">
          <strong>Last updated:</strong> {lastUpdatedDate}
        </p>

        {/* Sections */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">1. Agreement to Terms</h2>
          <p className="text-gray-600">
            Welcome to Pure Clean Shopping. These Terms and Conditions ("Terms") govern your access to and use of our website, services, and products (the "Service"). By accessing or using the Service, you agree to be bound by these Terms.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">2. Use License</h2>
          <p className="text-gray-600">
            Permission is granted to temporarily download one copy of the materials on Pure Clean Shopping's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>modify or copy the materials;</li>
            <li>use the materials for any commercial purpose or for any public display;</li>
            <li>attempt to reverse engineer any software contained on the website;</li>
            <li>remove any copyright or other proprietary notations from the materials;</li>
            <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">3. Disclaimer</h2>
          <p className="text-gray-600">
            The materials on Pure Clean Shopping's website are provided on an 'as is' basis. Pure Clean Shopping makes no warranties, expressed or implied, and hereby disclaims all other warranties including, without limitation, implied warranties of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">4. Limitations</h2>
          <p className="text-gray-600">
            In no event shall Pure Clean Shopping or its suppliers be liable for any damages arising out of the use or inability to use the materials on Pure Clean Shopping's website, even if Pure Clean Shopping or an authorized representative has been notified orally or in writing of the possibility of such damage.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">5. Governing Law</h2>
          <p className="text-gray-600">
            These terms and conditions are governed by and construed in accordance with the laws of USA, and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">6. Changes to Terms</h2>
          <p className="text-gray-600">
            We reserve the right, at our sole discretion, to update, change or replace any part of these Terms by posting updates and changes to our website. It is your responsibility to check our website periodically for changes.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">7. Contact Information</h2>
          <p className="text-gray-600">
            Questions about the Terms should be sent to us at{" "}
            <a href="mailto:contact@purecleanshopping.info" className="text-indigo-600 hover:underline">
              contact@purecleanshopping.info
            </a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
